import React, {  } from 'react';

import { numberFormatOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { NumberFormatInput, NumberFormatRuleSet } from './Intl.NumberFormat';

export const NumberToLocaleString = () => (
	<IntlFunction
		input={NumberFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString"
		header="Number.prototype.toLocaleString"
		description="Returns a string with a language-sensitive representation of this number."
		options={numberFormatOptions}
		ruleSet={NumberFormatRuleSet}
		template="##input:raw##.toLocaleString(##locale##, ##options##)" />
)